export default __webpack_public_path__ + "static/media/rocket.f8c38cc4.png";